<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
        <v-form>
            <ValidationProvider
                    mode="aggressive"
                    rules="requiredEmail|email"
                    :debounce="300"
                    v-slot="{ errors }">
                <v-text-field
                        type="email"
                        name="email"
                        label="Email"
                        v-model="form.email"
                        :error-messages=errors[0]
                        solo
                        :disabled="submitting"/>
            </ValidationProvider>
            <v-btn
                    type="submit"
                    block
                    large
                    class="mb-3 primary"
                    @click="submit()"
                    :disabled="invalid || submitting">SEND PASSWORD RESET LINK</v-btn>
            <v-btn
                    block
                    large
                    :to="{ name: 'Login' }"
                    :disabled="submitting">BACK</v-btn>
        </v-form>
    </ValidationObserver>
</template>

<script>
    import { mapMutations } from 'vuex'
    import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
    import { email, required } from 'vee-validate/dist/rules';
    import { sendPasswordResetEmail } from '@/firebase/firebase'

    extend('requiredEmail',
    {
        ...required,
        message: 'A valid email address is required.'
    });
    extend('email',
    {
        ...email,
        message: 'A valid email address is required.'
    });

    export default
    {
        name: 'password-recovery',
        components:
        {
            ValidationProvider,
            ValidationObserver
        },
        data ()
        {
            return {
                submitting: false,
                form:
                {
                    email: ''
                }
            }
        },
        methods:
        {
            ...mapMutations('common', ['SHOW_SNACKBAR_SUCCESS', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            async submit ()
            {
                if (await this.$refs.observer.validate())
                {
                    this.submitting = true;
                    this.HIDE_SNACKBAR();
                    try
                    {
                        await sendPasswordResetEmail(this.$firebaseAuth, this.form.email);
                        this.submitting = false;
                        this.form.email = '';
                        // You should call it on the next frame
                        window.requestAnimationFrame(() =>
                        {
                            this.$refs.observer.reset()
                        });
                        this.SHOW_SNACKBAR_SUCCESS('Password reset email sent.')
                    }
                    catch (error)
                    {
                        this.submitting = false;
                        let errorMessage;
                        switch (error.code)
                        {
                            case 'auth/user-not-found':
                                this.SHOW_SNACKBAR_SUCCESS('Password reset email sent.');
                                break
                            default:
                                errorMessage = 'System Error.';
                                this.SHOW_SNACKBAR_ERROR(errorMessage)
                        }
                        this.form.email = '';
                        // You should call it on the next frame
                        window.requestAnimationFrame(() =>
                        {
                            this.$refs.observer.reset()
                        });
                    }
                }
            }
        }
    }
</script>